import React from 'react';
import { useFormContext } from 'react-hook-form';
import withFormErrors from '../../hocs/withFormErrors';
import InputError from '../InputError';
import Label from '../../typography/Label';
import useTheme from '../../../branding/theme';
export const RadioPillGroup = ({ name, displayName, children, disabled = false, required = false, alignment = 'left', errorId, errorMessage, styles }) => {
    const methods = useFormContext();
    const checkedValue = methods.watch(name);
    const { sizing: { component: componentSizing } } = useTheme();
    const processedChildren = React.Children.map(children, (child) => (React.createElement(child.type, { ...child, ...child.props, name: name, disabled: disabled, checkedValue: checkedValue })));
    const mergedStyles = {
        width: '100%',
        textAlign: alignment,
        ...styles
    };
    return (React.createElement("div", { style: mergedStyles },
        displayName && (React.createElement(Label, { role: "legend", htmlFor: name, required: required, disabled: disabled }, displayName)),
        React.createElement("div", { style: { margin: `-${componentSizing.margin.small}` } }, processedChildren),
        errorId && React.createElement(InputError, { id: errorId }, errorMessage)));
};
export default withFormErrors(RadioPillGroup);
//# sourceMappingURL=index.js.map